import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { NotificationChannel, NotificationChannelCreate, NotificationChannelFilter } from '../data/notificationChannel';

export function createNotificationChannelService(client: AxiosInstance) {
  return createCrudService<NotificationChannel, NotificationChannelCreate, NotificationChannelFilter>(
    client,
    '/notifications/NotificationChannel',
    'id',
  );
}

export type NotificationChannelService = CrudService<NotificationChannel, NotificationChannelCreate, NotificationChannelFilter>;
